import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_5 = {
  title:
    "At this stage, equipment \nplacement is determined \naccording to business rules, and \nthe topology can be viewed or \nmodified as needed.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_320"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_318"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_05_map.png",
          imageStyle: { position: "absolute", bottom: "348px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_05_popup.png",
          imageStyle: { position: "absolute", bottom: "248px", right: "42px" },
        },
      ]}
      pageNumber={"ENG_319"}
    />
  ),
};
